import { render, staticRenderFns } from "./suppliers-edit.vue?vue&type=template&id=1a502f2e&scoped=true"
import script from "./suppliers-edit.vue?vue&type=script&lang=js"
export * from "./suppliers-edit.vue?vue&type=script&lang=js"
import style0 from "./suppliers-edit.vue?vue&type=style&index=0&id=1a502f2e&prod&lang=css"
import style1 from "./suppliers-edit.vue?vue&type=style&index=1&id=1a502f2e&prod&scoped=true&lang=css"
import style3 from "./suppliers-edit.vue?vue&type=style&index=3&id=1a502f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a502f2e",
  null
  
)

export default component.exports